<template>
  <div id="watermark" :style="[{left:(xNum+'px'),top:(yNum+'px')}]">{{ content }}</div>
</template>

<script>
export default {
  props: ["content"],
  data() {
    return {
      maxWidth: 0,
      maxHeight: 0,
      xNum: 20,
      yNum: 20,
      xDirection: 1,// 1-从左到右 2-从右到左
      yDirection: 1,// 1-从上到下 2-从下到上
      textWidth: 0,
      intervalId: null
    };
  },
  beforeDestroy() {
    // 清除计时器
    clearInterval(this.intervalId); // 清除计时器
    this.intervalId = null; // 设置为null
  },
  created() {
    // 计时器为空，操作
    this.intervalId = setInterval(() => {
      this.refreshText();
    }, 1000);
  },
  mounted() {
    this.maxWidth = document.body.scrollWidth
    this.maxHeight = document.body.scrollHeight
    this.textWidth = document.getElementById("watermark").getBoundingClientRect().width;
  },
  methods: {
    refreshText() {
      if (this.xDirection == 1 && this.xNum < this.maxWidth) {
        this.xNum += 20;
        if ((this.xNum + 40 + this.textWidth) >= this.maxWidth) {
          this.xDirection = 2;
        }
      } else if (this.xDirection == 2 && this.xNum > 0) {
        this.xNum -= 20;
        if ((this.xNum - 20) <= 0) {
          this.xDirection = 1;
        }
      }

      if (this.yDirection == 1 && this.yNum < this.maxHeight) {
        this.yNum += 20;
        if ((this.yNum + 40) >= this.maxHeight) {
          this.yDirection = 2;
        }
      } else if (this.yDirection == 2 && this.yNum > 0) {
        this.yNum -= 20;
        if ((this.yNum - 20) <= 0) {
          this.yDirection = 1;
        }
      }
    }
  },
};
</script>

<style scoped lang="stylus">
#watermark {
  position: absolute;
  z-index: 5000;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.3);
  transition: left 1s linear, top 1s linear;
  pointer-events: none;
}
</style>